import React from 'react';
import { FormControl, MenuItem, Select } from '@material-ui/core';
import { array, bool, func, object, string } from 'prop-types';


const CustomSelect = ({ handleChange, multiple, options, id, label, currentValue, defaultValue, name, className, disabledOptions }) => {
  const disabledLookup = new Set((disabledOptions || []).map(String));

  const listOptions = () => {
    return Object.entries(options).map(([key, value], index) => (
      <MenuItem key={index.toString()} value={key} disabled={disabledLookup.has(String(key))}>{value}</MenuItem>
    ));
  };

  return (
    <FormControl variant="standard" fullWidth className={`custom-input w-100 mt-3 ${className || ''}`}>
      <label className="d-block mb-0">{label}</label>
      <Select
        id={id}
        label={label}
        name={name}
        onChange={handleChange}
        value={currentValue }
        defaultValue={defaultValue}
        multiple={multiple}
      >
        {listOptions()}
      </Select>
    </FormControl>
  );
};

CustomSelect.propTypes = {
  handleChange: func.isRequired,
  options: object.isRequired,
  id: string.isRequired,
  label: string.isRequired,
  currentValue: string.isRequired,
  name: string.isRequired,
  multiple: bool,
  className: string,
  disabledOptions: array,
};

CustomSelect.defaultProps = {
  multiple: false,
  options: {},
  disabledOptions: [],
};

export default CustomSelect;
